import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

interface IMenuItem {
  type: string; // Possible values: link/dropDown/icon/separator/extLink
  name?: string; // Used as display text for item and title for separator type
  state?: string; // Router state
  icon?: string; // Material icon name
  svgIcon?: string; // UI Lib icon name
  tooltip?: string; // Tooltip text
  disabled?: boolean; // If true, item will not be appeared in sidenav.
  sub?: IChildItem[]; // Dropdown items
  badges?: IBadge[];
}
interface IChildItem {
  type?: string;
  name: string; // Display text
  state?: string; // Router state
  icon?: string; // Material icon name
  svgIcon?: string; // UI Lib icon name
  sub?: IChildItem[];
}

interface IBadge {
  color: string; // primary/accent/warn/hex color codes(#fff000)
  value: string; // Display text
}

@Injectable()
export class NavigationService {
  iconMenu: IMenuItem[] = [
    {
      name: 'Trang chủ',
      type: 'link',
      svgIcon: 'ulb_server',
      state: 'dashboard',
    },
    {
      name: 'Quản lý đơn hàng',
      type: 'link',
      tooltip: 'Documentation',
      icon: 'library_books',
      state: 'order',
    },
    {
      name: 'Quản lý level',
      type: 'link',
      tooltip: 'Documentation',
      icon: 'library_books',
      state: 'level',
    },
    {
      name: 'Quản lý sản phẩm',
      type: 'link',
      tooltip: 'Documentation',
      icon: 'library_books',
      state: 'product',
    },

    {
      name: 'Cấu hình tự động chia số',
      type: 'link',
      tooltip: 'Documentation',
      icon: 'library_books',
      state: 'autoShareOrder',
    },
    {
      name: 'Chia số cho COD',
      type: 'link',
      tooltip: 'Documentation',
      icon: 'library_books',
      state: 'dispenseCod',
    },
    {
      name: 'Quản lý kho hàng',
      type: 'link',
      tooltip: 'Documentation',
      icon: 'library_books',
      state: 'stock',
    },
    {
      name: 'COD lên đơn',
      type: 'link',
      tooltip: 'Documentation',
      icon: 'library_books',
      state: 'createOrders',
    },
    {
      name: 'Báo cáo',
      type: 'dropDown',
      tooltip: 'Documentation',
      svgIcon: 'ulb_server',
      state: 'report',
      sub: [
        { name: 'order', state: 'order', icon: 'library_books', type: 'link' },
        {
          name: 'Learning Management',
          state: 'learning-management',
          icon: 'library_books',
        },
      ],
    },
    {
      name: 'Chia số cho Sale',
      type: 'link',
      tooltip: 'Documentation',
      icon: 'library_books',
      state: 'dispenseSale',
    },
    {
      name: 'Thêm đơn hàng C3',
      type: 'link',
      tooltip: 'Documentation',
      icon: 'library_books',
      state: 'addOrderC3',
    },
    {
      name: 'Quản lý bưu cục',
      type: 'link',
      tooltip: 'Documentation',
      icon: 'library_books',
      state: 'delivery',
    },
    {
      name: 'Quản lý loại từ điển',
      type: 'link',
      tooltip: 'Documentation',
      icon: 'library_books',
      state: 'dictionarytype',
    },
    {
      name: 'Bao cao test',
      type: 'link',
      tooltip: 'Bao cao test',
      icon: 'library_books',
      state: 'sample',
    },
  ];

  // Icon menu TITLE at the very top of navigation.
  // This title will appear if any icon type item is present in menu.
  iconTypeMenuTitle = 'Frequently Accessed';
  // sets iconMenu as default;
  menuItems = new BehaviorSubject<IMenuItem[]>(this.iconMenu);
  // navigation component has subscribed to this Observable
  menuItems$ = this.menuItems.asObservable();
  constructor() {}

  // Customizer component uses this method to change menu.
  // You can remove this method and customizer component.
  // Or you can customize this method to supply different menu for
  // different user type.
  publishNavigationChange(menuType: string) {
    switch (menuType) {
      case 'separator-menu':
        this.menuItems.next([]);
        break;
      case 'icon-menu':
        this.menuItems.next(this.iconMenu);
        break;
      default:
        this.menuItems.next([]);
    }
  }
}
